import {BottomPanelView} from '@gongxigames/framework/slot/modules/bottompanel/BottomPanelView';
import {Sprite} from 'pixi.js';
import {DeviceType, ScreenParameters} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';

export class BottomPanelFullScreenView extends BottomPanelView {
    public static platform: DeviceType = DeviceType.DESKTOP;

    public onResized(screenParams: ScreenParameters): void {
        super.onResized(screenParams);

        const bg = this._sprite.getChildByName<Sprite>('bg');

        bg.width = screenParams.width + Math.ceil(screenParams.x / screenParams.scale) * 2;
        bg.x = -screenParams.x / screenParams.scale;
        this._sprite.y = screenParams.y / screenParams.scale;
    }
}
